* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

#anti-tampering-policy-section {
  margin: 30px 0 0 20px;
  width: 640px;
  height: auto;
  cursor: default;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  gz-text {
    line-height: 18px;
    cursor: text;
  }

  gz-title {
    text-transform: uppercase;
  }

  #anti-tampering-section {
    #anti-tampering-checkbox-title {
      margin-left: 16px;
      text-transform: none;
    }
  }

  #pre-tampering-section {
    #pre-tampering-title {
      color: var(--chart-300-icon-buttons);
      margin-top: 18px;
    }

    #pre-tampering-text {
      height: 48px;
      margin-top: 18px;
    }
  }

  #vulnerable-drivers-section {
    display: flex;
    margin-top: 12px;

    #vulnerable-drivers-checkbox-form {
      width: 265px;
    }

    #vulnerable-drivers-radio-group-form {
      width: 375px;
    }

    gz-radio:not(:first-child) {
      margin-top: 22px;
    }
  }

  #post-tampering-section {
    margin-top: 38px;

    #post-tampering-title {
      color: var(--chart-302-icon-buttons-titles);
    }

    #post-tampering-text {
      margin-top: 25px;
    }
  }

  #callback-evasion-section {
    display: flex;
    margin-top: 30px;

    #callback-evasion-checkbox-form {
      width: 265px;
    }

    #callback-evasion-actions-section {
      width: 375px;

      #callback-evasion-actions-radio-group {
        display: flex;
        margin-top: 12px;

        gz-radio:not(:first-child) {
          margin-left: 20px;
        }

        gz-radio:first-child {
          margin-left: 25px;
        }
      }
    }


  }


}
